<template>
  <div id="match_mini">
    <div
      class="match live-match-mini columns is-gapless is-multiline is-unselectable"
    >
      <HeaderMatch
        :league="league"
        :time-level-class="timeLevelClass"
        :is-favorite="isFavorite"
        :mini="mini"
        @favorite="() => $emit('favorite')"
        @view="() => $emit('view')"
      />
      <div class="column is-full match-body">
        <div class="stats-info">
          <div class="info">
            <div class="info-header">
              <p>{{ home.name }}</p>
              <WinCoef class="rate" :value="home.winCoef" />
              <span v-if="home.redCard" class="red-card">
                {{ home.redCard }}
              </span>
              <span v-if="home.yellowCard" class="yellow-card">
                {{ home.yellowCard }}
              </span>
            </div>
            <div class="info-body">
              <div
                v-for="(stat, index) in stats.home"
                :key="index"
                class="info-item"
                :class="stat.$class"
              >
                {{ stat.key }}: {{ stat.value }}
              </div>
            </div>
          </div>

          <div class="score">
            <div
              class="block"
              style="background-color: #c5c5c5"
              :class="[homeLevelClass]"
            ></div>
            <ScoreInfo
              :id="match.id"
              :time="time"
              :home-score="home.score"
              :away-score="away.score"
              :first-time="match.firstTime"
              :is-away-goal="isAwayGoal"
              :is-home-goal="isHomeGoal"
              :is-away-no-goal="isAwayNoGoal"
              :is-home-no-goal="isHomeNoGoal"
              :ended="match.ended"
            />
            <div
              class="block"
              style="background-color: #c5c5c5"
              :class="[awayLevelClass]"
            ></div>
          </div>

          <div class="info">
            <div class="info-header last">
              <WinCoef class="rate" :value="away.winCoef" />
              <span v-if="away.redCard" class="red-card">
                {{ away.redCard }}
              </span>
              <span v-if="away.yellowCard" class="yellow-card">{{
                away.yellowCard
              }}</span>
              <p>{{ away.name }}</p>
            </div>
            <div class="info-body" style="justify-content: end">
              <div
                v-for="(stat, index) in stats.away"
                :key="index"
                class="info-item"
                :class="stat.$class"
              >
                {{ stat.key }}: {{ stat.value }}
              </div>
            </div>
          </div>
        </div>
        <div class="stats-info-mobile">
          <div class="score">
            <ScoreInfo
              :id="match.id"
              :time="time"
              :home-score="home.score"
              :away-score="away.score"
              :first-time="match.firstTime"
              :is-away-goal="isAwayGoal"
              :is-home-goal="isHomeGoal"
              :is-away-no-goal="isAwayNoGoal"
              :is-home-no-goal="isHomeNoGoal"
              :ended="match.ended"
            />
          </div>
          <div style="display: flex; flex-direction: column; width: 100%">
            <div class="info-wrap">
              <div
                class="block"
                style="background-color: #c5c5c5"
                :class="[homeLevelClass]"
              ></div>
              <div class="info">
                <div class="info-header">
                  <p>{{ home.name }}</p>
                  <span v-if="home.redCard" class="red-card">
                    {{ home.redCard }}
                  </span>
                  <span v-if="home.yellowCard" class="yellow-card">
                    {{ home.yellowCard }}
                  </span>
                  <WinCoef class="rate" :value="home.winCoef" />
                </div>
                <div class="info-body">
                  <div
                    v-for="(stat, index) in stats.home"
                    :key="index"
                    class="info-item"
                    :class="stat.$class"
                  >
                    {{ stat.key }}: {{ stat.value }}
                  </div>
                </div>
              </div>
            </div>

            <div class="info-wrap">
              <div
                class="block"
                style="background-color: #c5c5c5"
                :class="[awayLevelClass]"
              ></div>
              <div class="info">
                <div class="info-header">
                  <p>{{ away.name }}</p>
                  <span v-if="away.redCard" class="red-card">
                    {{ away.redCard }}
                  </span>
                  <span v-if="away.yellowCard" class="yellow-card">
                    {{ away.yellowCard }}
                  </span>
                  <WinCoef class="rate" :value="away.winCoef" />
                </div>
                <div class="info-body">
                  <div
                    v-for="(stat, index) in stats.away"
                    :key="index"
                    class="info-item"
                    :class="stat.$class"
                  >
                    {{ stat.key }}: {{ stat.value }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <SignalsLive v-if="liveSignals.length" :signals="liveSignals" />
  </div>
</template>

<script>
import ScoreInfo from "./common/ScoreInfo.vue";
import WinCoef from "./common/WinCoef.vue";
import SignalsLive from "./common/SignalsLive.vue";
import HeaderMatch from "./common/HeaderMatch.vue";

export default {
  name: "LiveMatchMini",
  components: { ScoreInfo, WinCoef, SignalsLive, HeaderMatch },
  props: {
    id: Number,
    timeLevel: Number,
    away: Object,
    home: Object,
    part: String,
    time: Number,
    league: String,
    mini: Boolean,
    isFavorite: Boolean,
    match: Object,
    permision: String,
    liveSignals: {
      type: Array,
      default: () => [],
    },
    // CSS Classes
    timeLevelClass: String,
    homeLevelClass: String,
    awayLevelClass: String,
  },
  data() {
    return {
      statList: [
        { title: "Dang. Attack", key: "dAtk" },
        { title: "Shots", key: "shots" },
        { title: "On Target", key: "sOn" },
        { title: "Off Target", key: "sOff" },
      ],
    };
  },
  computed: {
    isHomeGoal() {
      return this.home.lastGoal
        ? new Date().getTime() - this.home.lastGoal < 60 * 1000
        : false;
    },
    isAwayGoal() {
      return this.away.lastGoal
        ? new Date().getTime() - this.away.lastGoal < 60 * 1000
        : false;
    },
    isHomeNoGoal() {
      return this.home.lastNoGoal
        ? new Date().getTime() - this.home.lastNoGoal < 60 * 1000
        : false;
    },
    isAwayNoGoal() {
      return this.away.lastNoGoal
        ? new Date().getTime() - this.away.lastNoGoal < 60 * 1000
        : false;
    },
    stats() {
      return {
        home: this.statList.map((stat) => {
          const { value, level } = this.home[stat.key];
          return {
            ...stat,
            value,
            $class: this.$utils.match.getLevelClass(level, "is"),
          };
        }),
        away: this.statList.map((stat) => {
          const { value, level } = this.away[stat.key];
          return {
            ...stat,
            value,
            $class: this.$utils.match.getLevelClass(level, "is"),
          };
        }),
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@use "../scss/variables" as *;

#match_mini {
  border-radius: 26px;
  overflow: hidden;
  margin-bottom: 20px;

  .team-level-success {
    background-color: var(--success-color) !important;
  }

  .team-level-danger {
    background-color: var(--danger-color) !important;
  }

  .team-level-warning {
    background-color: var(--warning-color) !important;
  }

  .match-body {
    padding: 20px 40px 20px 40px !important;
    display: flex;
    align-items: center;
    height: max-content;

    .stats-info {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;

      /* Equal-width side columns so the score block stays centered
         no matter how wide the team names / stat badges are */
      > .info {
        flex: 1 1 0;
        min-width: 0;
      }
    }

    .info {
      display: flex;
      flex-direction: column;

      .info-header {
        display: flex;
        align-items: center;
        gap: 10px;
        flex-wrap: wrap;

        .yellow-card {
          background-color: #ffe500;
          padding: 5px 10px 5px 10px;
          width: 28px;
          height: 30px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 4px;
          color: #151515;
          font-weight: 400;
          font-size: 12px;
          line-height: 14.52px;
        }

        .red-card {
          background-color: #ff4e4e;
          padding: 5px 10px 5px 10px;
          width: 26px;
          height: 30px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 4px;
          color: white;
          font-weight: 400;
          font-size: 12px;
          line-height: 14.52px;
        }

        .rate {
          font-weight: 400;
          font-size: 16px;
          line-height: 19.84px;
          letter-spacing: 0.02em;
        }

        p {
          font-weight: 500;
          font-size: 16px;
          line-height: 19.86px;
          color: var(--font-color);
        }
      }

      .last {
        justify-content: end;
      }

      .info-body {
        display: flex;
        align-items: center;
        gap: 6px;
        padding-top: 22px;
        color: var(--shots-body-color);
        flex-wrap: wrap;

        .is-danger {
          background-color: var(--danger-background) !important;
          color: var(--shots-body-color) !important;
        }

        .is-warning {
          background-color: var(--warning-background) !important;
          color: var(--shots-body-color) !important;
        }

        .is-success {
          background-color: var(--success-background) !important;
          color: var(--shots-body-color) !important;
        }

        .info-item {
          display: flex;
          align-items: center;
          gap: 9px;
          padding: 6px 12px 6px 12px;
          border-radius: 100px;
          font-weight: 700;
          font-size: 12px;
          line-height: 15.02px;
          background-color: rgb(255, 255, 255);
          color: rgb(37, 37, 37);
        }

        .shots {
          color: var(--shots-color);
          background-color: var(--shots-body-color) !important;
        }
      }
    }

    .block {
      height: 80px;
      width: 10px;
      border-radius: 10px;
      margin: 0;
    }

    .score {
      display: flex;
      align-items: center;
      gap: 92px;

      .score-info {
        display: flex;
        flex-direction: column;
        align-items: center;

        .goals {
          display: flex;
          align-items: center;
          gap: 30px;
          padding: 10px 20px 10px 20px;
          background-color: var(--shots-body-color);
          border-radius: 26px;
          margin-top: 10px;

          .goal_wrap {
            position: relative;

            .score_change {
              position: absolute;
              font-size: 12px;
              color: var(--danger-color);
              background-color: #fff;
              border-radius: 16px;
              padding: 5px 12px;
              text-transform: uppercase;
              font-family: sans-serif;
              font-weight: bolder;
              animation: goal 1s infinite;
              transform-origin: center;
            }

            .left {
              bottom: 35px;
              left: 20px;
            }

            .right {
              bottom: 35px;
              right: 20px;
            }

            @keyframes goal {
              0% {
                transform: translateY(0) scale(1);
              }

              50% {
                transform: translateY(-10px) scale(1.1);
              }

              100% {
                transform: translateY(0) scale(1);
              }
            }
          }

          .goals-block {
            height: 14px;
            width: 1px;
            background-color: #c5c5c5;
          }

          span {
            font-weight: 700;
            font-size: 24px;
            line-height: 30.05px;
            color: var(--font-color);
          }
        }
      }
    }

    .stats-info-mobile {
      display: none;
      align-items: center;
      width: 100%;
      height: 100%;

      .score {
        width: 80%;
        height: 100%;
      }

      .score-info {
        height: 100%;

        .goals {
          height: 100%;
          justify-content: space-between;
          padding: 50px 13px 50px 13px;
        }
      }

      .info-wrap {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        gap: 20px;
        height: max-content;
      }
    }

    .stats-info-mobile .info-wrap:first-child {
      padding-bottom: 20px;
      margin-bottom: 20px;
      border-bottom: 1px solid var(--match-border-color);
    }
  }

  .live-match-mini {
    margin: 0;
    background-color: var(--league-body-color);

    .title_league {
      font-size: 18px;
      font-weight: 700;
      line-height: 22.54px;
      color: var(--font-color);
      transition: all 0.3s;
    }

    .view path {
      fill: var(--font-color);
      transition: fill 0.3s;
    }

    .time {
      color: var(--font-color);
      font-size: 24px;
      font-weight: 700;
      line-height: 30.05px;
    }

    .match-team {
      &.team-level-success {
        background: var(--success-background);
      }

      &.team-level-warning {
        background: var(--warning-background);
      }

      &.team-level-danger {
        background: var(--danger-background);
      }

      & > .columns {
        width: 100%;

        & > .column.is-half-desktop {
          display: inline-flex;
          align-items: center;
          flex-wrap: wrap;

          & > .penalty-card {
            margin-left: 0.1rem;
          }
        }
      }
    }

    .match-score {
      display: inline-block;
      width: 1.5em;
      border-radius: 100%;

      &.is-active {
        background-color: #ffe6f3;
        border-radius: 4px;
        color: #ff0046;
        font-weight: 700;
        margin: auto;
        min-width: 20px;
      }

      & ~ span {
        padding: 0 0.3rem;
      }
    }
  }
}

@media screen and (max-width: $tablet) {
  #match_mini .match-body {
    .stats-info {
      display: none;
    }

    .score .score-info {
      display: flex;
      flex-direction: row;

      h1 {
        font-size: 40px;
      }

      .goals {
        flex-direction: column;
        margin-top: 0;
        margin-left: 41px;
        width: 50px;
        padding: 13px 0;

        .goals-block {
          height: 1px;
          width: 14px;
          background-color: #c5c5c5;
        }
      }
    }

    .stats-info-mobile {
      display: flex;

      .info-header {
        p {
          font-weight: 700;
        }
      }
    }
  }
}

@media screen and (max-width: $mobile) {
  #match_mini .match-body {
    padding: 30px 30px 22px 30px !important;

    .stats-info-mobile {
      align-items: normal;

      .score {
        height: auto;
        margin-right: 10px;
      }

      .score-info {
        h1 {
          font-size: 22px;
        }

        .goals {
          margin-left: 20px;
        }
      }

      .info-wrap {
        align-items: normal;

        .block {
          height: auto;
        }
      }
    }
  }
}

@media screen and (max-width: 460px) {
  #match_mini .match-body {
    padding: 10px !important;
  }
}

@media screen and (min-width: 1024px) {
  .stats-info {
    .score {
      margin-left: 15px;
      margin-right: 15px;
    }
  }
}
</style>
